import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MailService } from './mail.service';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { InicioService } from 'src/app/inicio/inicio/inicio.service';
import { mail } from 'src/app/inicio/inicio/models/email';
import { environment } from 'src/environments/environment';


export interface DialogData {
  nrocta: string;
  usuario: string;
  idtributo:string;
}

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.scss'],
  providers: [MailService],
})
export class MailComponent implements OnInit {

  nrocta: string;
  email: string ;
  emailr: string;
  usuario:string;
  idtributo;
  guardarEmail= new mail();

  constructor(private service: MailService,  public dialogRef: MatDialogRef<MailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,private services:InicioService
  ) {
    this.datos(data.nrocta,data.usuario,data.idtributo);
  }

  emailFormControl = new FormControl('', [Validators.required,Validators.email,
  ]);

  emailFormControlr = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  matcher = new MyErrorStateMatcher();
  matcherr = new MyErrorStateMatcher();

  Adherir() {
   
    this.guardarEmail.email = this.emailFormControl.value;
    this.guardarEmail.idJurisdiccion = environment.codigoJur;
    for(var i = 0; i < this.idtributo.length; i++){
        if(this.nrocta == this.idtributo[i].clave_bien){
          this.guardarEmail.idTributoContribuyente = this.idtributo[i].clave_bien;
        }
    }
    this.guardarEmail.usrMod = 'EmisionWebCidi';
    
    this.services.addEmail(this.guardarEmail).subscribe(result => {
     
    });
    alert("Su correo electrónico fué ingresado correctamente.");
    this.dialogRef.close();
  //  this.dialogRef.close();

  }
  datos(nrocta: string, usuario: string,idtributo:string): void {
    this.nrocta = nrocta;
    this.usuario = usuario;
    this.idtributo=idtributo;
  }

  ngOnInit() {
  }

}
